export var CompareFunction;
(function (CompareFunction) {
    CompareFunction[CompareFunction["Never"] = 0] = "Never";
    CompareFunction[CompareFunction["Less"] = 1] = "Less";
    CompareFunction[CompareFunction["Equal"] = 2] = "Equal";
    CompareFunction[CompareFunction["LessEqual"] = 3] = "LessEqual";
    CompareFunction[CompareFunction["Greater"] = 4] = "Greater";
    CompareFunction[CompareFunction["NotEqual"] = 5] = "NotEqual";
    CompareFunction[CompareFunction["GreaterEqual"] = 6] = "GreaterEqual";
    CompareFunction[CompareFunction["Always"] = 7] = "Always";
    CompareFunction[CompareFunction["Off"] = 8] = "Off";
})(CompareFunction || (CompareFunction = {}));
